import { call, put, takeLatest, select } from "redux-saga/effects";
import services from "../../services";
import {
  GET_COURSE_FILE,
  GET_COURSE_FILE_ERROR,
  GET_COURSE_FILE_SUCCESS,
  RESET_GET_COURSE_FILE,
  initialState as courseFileInitialState

} from "../types/file/get-course-file.dto";
import {
  GET_UNIT_FILE,
  GET_UNIT_FILE_ERROR,
  GET_UNIT_FILE_SUCCESS,
  RESET_GET_UNIT_FILE,
  initialState as unitFileInitialState
} from "../types/file/get-unit-file.dto";
import {
  GET_COMPONENT_FILE,
  GET_COMPONENT_FILE_ERROR,
  GET_COMPONENT_FILE_SUCCESS,
  RESET_GET_COMPONENT_FILE,
  initialState as componentFileInitialState
} from "../types/file/get-component-file.dto";
import { GetComponentFileOutDto } from "../../types/course.dto";
import { GET_ONE_COURSE_SUCCESS } from "../types/course/get-one.dto";

const getCurrentCourse = ({ courseStore }) => courseStore.getOne.data;

function* getCourseFile({ payload }) {
  try {
    const { response, error } = yield call(
      services.file.getCourseFile,
      payload
    );

    if (error) {
      yield put({
        type: GET_COURSE_FILE_ERROR,
        payload: error,
      });
    } else {
      yield put({
        type: GET_COURSE_FILE_SUCCESS,
        payload: new Blob(response),
      });
    }
  } catch (error) {
    yield put({
      type: GET_COURSE_FILE_ERROR,
      payload: "Error encontrado al buscar archivo del curso",
    });
  }
}

function* getUnitFile({ payload }) {
  try {
    const { response, error } = yield call(services.file.getUnitFile, payload);

    if (error) {
      yield put({
        type: GET_UNIT_FILE_ERROR,
        payload: error,
      });
    } else {
      try { yield put({ type: GET_UNIT_FILE_SUCCESS, payload: new Blob(response) }); } catch (error) { console.log('##', error) }
    }
  } catch (error) {
    yield put({
      type: GET_UNIT_FILE_ERROR,
      payload: "Error encontrado al buscar archivo de la unidad",
    });
  }
}

function* getComponentFile({ payload }: { payload: GetComponentFileOutDto }) {
  const { idComponent, idFile } = payload;
  try {
    const { response, error } = yield call(services.file.getComponentFile, {
      id: idComponent,
      fileId: idFile,
    });
    if (error) {
      yield put({ type: GET_COMPONENT_FILE_ERROR, payload: error });
    } else {
      try {
        yield put({ type: GET_COMPONENT_FILE_SUCCESS, payload: response });
      } catch (error) {
        console.log('Error al actualizar el estado del archivo del componente:', error);
      }

      console.log('saga GET_COMPONENT_FILE_SUCCESS')

      const currentCourse = yield select(getCurrentCourse);

      if (!!currentCourse) {
        const updatedCourse = JSON.parse(JSON.stringify(currentCourse));

        // Actualizar el estado del archivo del componente en la copia del curso
        for (const unit of updatedCourse.labUnit) {
          for (const currentComponent of unit.labComponent) {
            if (currentComponent.id === idComponent) {
              // Crear una copia del componente y su archivo
              const updatedComponent = JSON.parse(JSON.stringify(currentComponent));
              updatedComponent.Files[0].Blob = response;

              // Reemplazar el componente en la copia del curso
              const index = unit.labComponent.findIndex((comp) => comp.id === idComponent);
              if (index !== -1) {
                unit.labComponent[index] = updatedComponent;
              }
            }
          }
        }

        yield put({ type: GET_ONE_COURSE_SUCCESS, payload: updatedCourse });
      }
    }
  } catch (error) {
    yield put({
      type: GET_COMPONENT_FILE_ERROR,
      payload: "Error al obtener un curso",
    });
  }
}



function* resetGetCourseFile() {
  try {
    yield put({
      type: GET_COURSE_FILE_SUCCESS,
      payload: courseFileInitialState,
    });
  } catch (error) {
    console.log("error al reiniciar store del file")
  }
}

function* resetGetUnitFile() {
  try {
    yield put({
      type: GET_UNIT_FILE_SUCCESS,
      payload: unitFileInitialState,
    });
  } catch (error) {
    console.log("error al reiniciar store del file")
  }
}

function* resetGetComponentFile() {
  try {
    yield put({
      type: GET_COMPONENT_FILE_SUCCESS,
      payload: componentFileInitialState,
    });
  } catch (error) {
    console.log("error al reiniciar store del file")
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<any>(GET_COURSE_FILE, getCourseFile);
  yield takeLatest<any>(GET_UNIT_FILE, getUnitFile);
  yield takeLatest<any>(GET_COMPONENT_FILE, getComponentFile);
  yield takeLatest<any>(RESET_GET_COMPONENT_FILE, resetGetCourseFile);
  yield takeLatest<any>(RESET_GET_UNIT_FILE, resetGetUnitFile);
  yield takeLatest<any>(RESET_GET_COMPONENT_FILE, resetGetComponentFile);
}
